import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://gznwnelgsrvyiyxnsnyc.supabase.co'
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || ''

console.log('Supabase URL:', supabaseUrl)
console.log('Supabase Anon Key length:', supabaseAnonKey ? supabaseAnonKey.length : 0)

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Export the anon key for use in Edge Function calls
export const SUPABASE_ANON_KEY = supabaseAnonKey
export const SUPABASE_URL = supabaseUrl 